const state = {
    navFromValue:null,
    
};

const getters = {
    GET_NAV_FROM_VALUE: (state) => {
        return state.navFromValue;
    },
   

};


const actions = {

    CLEAR_GUIDE_STORE: ({ commit }) => {
        commit('clearGuideStore');
    },
    SET_NAV_FROM_VALUE: ({ commit }, navFrom) => {

        commit('saveNavFromValue', navFrom);

    },
    
};


const mutations = {
    clearGuideStore: (state) => {
       
       state.navFromValue=null;
      
    },
    saveNavFromValue: (state, navFrom) => {
        state.navFromValue = navFrom;
    },
  


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}